module.exports = __webpack_public_path__ + "static/img/mac4.cda01b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hiw/mac4.png
// module id = 652
// module chunks = 1